<jhi-spinner *ngIf="loading"></jhi-spinner>
<div class="container mt-4">
  <div class="mb-2">
<nav class="breadcrumb-container" aria-label="Percorso di navigazione">
  <ol class="breadcrumb">
    <li class="breadcrumb-item" *ngIf="configurazioneGeneraleService && configurazioneGeneraleService.configurazione && configurazioneGeneraleService.configurazione.backButtonIsPresent"><a (click)="goToHome()">Home</a><span class="separator">/</span></li>
    <li class="breadcrumb-item"><a (click)="goToServizi()">Servizi</a><span class="separator">/</span></li>
    <li class="breadcrumb-item" *ngFor="let bread of funzioneServizio?.breadcrumbs"><a href="{{bread.url}}">{{bread.label}}</a><span class="separator">/</span></li>
    <li class="breadcrumb-item active"><a href="javascript:void(0)"><span *ngIf="funzioneServizio ">{{funzioneServizio.nmTitolo}}</span></a></li>
  </ol>
</nav>
</div>
  <div class="row">
    <div class="col-12 text-center">
      <div class="steppers">
        <div class="steppers-header">
          <ul class="d-flex justify-content-between w-100">
            <li class="active"><span class="text-capitalize">Informativa sulla privacy</span></li>
            <li><span class="text-capitalize">Dati</span><span class="visually-hidden">Attivo</span></li>
            <li><span class="text-capitalize">Riepilogo</span></li>
          </ul>
          <span class="steppers-index" aria-hidden="true">1/3</span>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center mb-3 mt-2">
    <div class="col-12 col-lg-8 pb-40 pb-lg-80">
      <p class="text-paragraph mb-lg-4">
        Il Comune di <span *ngIf="configurazioneGeneraleService.configurazione">{{configurazioneGeneraleService.configurazione.nome}}</span> gestisce i dati personali forniti e liberamente comunicati sulla base dell’articolo 13 del Regolamento (UE) 2016/679 General data protection regulation (Gdpr) e degli articoli 13 e successive modifiche e integrazione del decreto legislativo (di seguito d.lgs) 267/2000 (Testo unico enti locali).
      </p>
      <p class="text-paragraph mb-0">
        Per i dettagli sul trattamento dei dati personali consulta l’
        <a *ngIf="configurazioneGeneraleService.configurazione" [attr.href]="configurazioneGeneraleService.configurazione.linkPrivacy" class="t-primary">informativa sulla privacy.</a>
      </p>

      <div class="form-check mt-4 mb-3 mt-md-40 mb-lg-40">
        <div class="checkbox-body d-flex align-items-center">
          <input type="checkbox" id="privacy" name="privacy-field" value="privacy-field" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}">
          <label class="title-small-semi-bold pt-1" for="privacy">Ho letto e compreso l’informativa sulla privacy</label>
        </div>
      </div>
      <button type="button" class="btn btn-primary mobile-full background-primary" [disabled]="!isChecked" (click)="goToIstanza()">
        <span class="">Avanti</span>
      </button>
    </div>
  </div>
</div>
